<!-- 
    Hello Simple Table!!
    Designed by Rahul 
-->

<table class="table-simple-v2" *ngIf="tableData.length; else message">
    <thead class="thead">
        <tr class="thead-row">
            <th class="th-data" *ngFor="let column of configData.columns">{{column.columnName}}</th>
        </tr>        
    </thead>
    <tbody class="tbody">
        <tr class="tbody-row" *ngFor="let data of tableData">
            <td class="td-data"  *ngFor="let column of configData.columns">
                <span *ngIf="column['columnDataType'] === 'STRING' ">
                    {{data[column['columnData']]}}
                </span> 
                <span (click)="column['apiUrl'] && columnAction(column, data)" *ngIf="column['columnDataType'] === 'ICON-API' ">                    
                    <span [class]="'ICON-'+column['columnData']"></span>
                </span>                
            </td>
        </tr>
    </tbody>
</table>
<ng-template #message>
    <!-- we can multiple failure message  here and handle it in typescript -->
    <div class="message">
        There are no available documents for this order.
    </div>    
</ng-template>